import styled from 'styled-components'
import Image from 'next/image'

import { onlyForSafari } from '../../styles'

const Styled = styled(Image)`
  object-fit: contain;
  object-position: center center;

  /* TODO: remove me when it will be fixed
      (see https://nextjs.org/docs/api-reference/next/future/image#known-browser-bugs) */
  ${onlyForSafari`
    &[loading='lazy'] {
      clip-path: inset(0.6px);
    }
  `}
`

export default Styled
